module.exports = __webpack_public_path__ + "static/media/three-dots-light.7627bc82.svg";